import { OverallSatisfactionScoreQuestion } from 'screens/WidgetGenerator/utils/misc';
import { AspectValues } from 'types/aspect';

/* eslint-disable max-lines */
export const mockServicesBarWidgetData: OverallSatisfactionScoreQuestion[] = [
  {
    score: {
      positive: 54,
      negative: 13,
      neutral: 33,
    },
    genericQuestionId: 15,
    text: 'How is the overall quality with which the Abilene government provides services to residents of Abilene today compared to 3 years ago?',
    aspectValue: AspectValues.QUALITY_OF_LIFE,
  },
  {
    score: {
      positive: 46,
      negative: 26,
      neutral: 29,
    },
    genericQuestionId: 16,
    text: 'How likely are you to recommend Abilene as a place to live?',
    aspectValue: AspectValues.QUALITY_OF_LIFE,
    previousCycle: {
      score: {
        positive: 48,
        negative: 24,
        neutral: 28,
      },
    },
  },
  {
    score: {
      positive: 61,
      negative: 22,
      neutral: 18,
    },
    genericQuestionId: 19,
    text: 'How likely are you to be living in Abilene 5 years from now?',
    aspectValue: AspectValues.QUALITY_OF_LIFE,
    previousCycle: {
      score: {
        positive: 64,
        negative: 17,
        neutral: 18,
      },
    },
  },
  {
    score: {
      positive: 32,
      negative: 27,
      neutral: 40,
    },
    genericQuestionId: 25,
    text: 'Overall quality of services provided by Abilene',
    aspectValue: AspectValues.CHARACTERISTIC,
    previousCycle: {
      score: {
        positive: 40,
        negative: 24,
        neutral: 36,
      },
    },
  },
  {
    score: {
      positive: 32,
      negative: 36,
      neutral: 32,
    },
    genericQuestionId: 26,
    text: 'Availability of affordable housing',
    aspectValue: AspectValues.CHARACTERISTIC,
    previousCycle: {
      score: {
        positive: 38,
        negative: 31,
        neutral: 31,
      },
    },
  },
  {
    score: {
      positive: 26,
      negative: 40,
      neutral: 34,
    },
    genericQuestionId: 27,
    text: 'Availability of jobs that pay a living wage',
    aspectValue: AspectValues.CHARACTERISTIC,
    previousCycle: {
      score: {
        positive: 29,
        negative: 39,
        neutral: 31,
      },
    },
  },
  {
    score: {
      positive: 45,
      negative: 28,
      neutral: 27,
    },
    genericQuestionId: 28,
    text: 'Access to quality health care services',
    aspectValue: AspectValues.CHARACTERISTIC,
    previousCycle: {
      score: {
        positive: 50,
        negative: 22,
        neutral: 28,
      },
    },
  },
  {
    score: {
      positive: 50,
      negative: 20,
      neutral: 30,
    },
    genericQuestionId: 29,
    text: 'Access to quality education',
    aspectValue: AspectValues.CHARACTERISTIC,
    previousCycle: {
      score: {
        positive: 53,
        negative: 16,
        neutral: 31,
      },
    },
  },
  {
    score: {
      positive: 34,
      negative: 39,
      neutral: 26,
    },
    genericQuestionId: 30,
    text: 'Ease of getting around by public transportation',
    aspectValue: AspectValues.CHARACTERISTIC,
    previousCycle: {
      score: {
        positive: 29,
        negative: 38,
        neutral: 33,
      },
    },
  },
  {
    score: {
      positive: 42,
      negative: 29,
      neutral: 29,
    },
    genericQuestionId: 31,
    text: 'Sense of overall safety',
    aspectValue: AspectValues.CHARACTERISTIC,
    previousCycle: {
      score: {
        positive: 42,
        negative: 25,
        neutral: 33,
      },
    },
  },
  {
    score: {
      positive: 39,
      negative: 29,
      neutral: 32,
    },
    genericQuestionId: 32,
    text: 'Sense of community among residents',
    aspectValue: AspectValues.CHARACTERISTIC,
    previousCycle: {
      score: {
        positive: 43,
        negative: 28,
        neutral: 29,
      },
    },
  },
  {
    score: {
      positive: 39,
      negative: 31,
      neutral: 31,
    },
    genericQuestionId: 33,
    text: 'Acceptance of residents of all backgrounds',
    aspectValue: AspectValues.CHARACTERISTIC,
    previousCycle: {
      score: {
        positive: 43,
        negative: 29,
        neutral: 28,
      },
    },
  },
  {
    score: {
      positive: 29,
      negative: 37,
      neutral: 33,
    },
    genericQuestionId: 34,
    text: 'Ability of residents to give input to the Abilene government',
    aspectValue: AspectValues.CHARACTERISTIC,
    previousCycle: {
      score: {
        positive: 32,
        negative: 37,
        neutral: 32,
      },
    },
  },
  {
    score: {
      positive: 28,
      negative: 39,
      neutral: 33,
    },
    genericQuestionId: 35,
    text: 'Overall cleanliness and maintenance',
    aspectValue: AspectValues.CHARACTERISTIC,
    previousCycle: {
      score: {
        positive: 33,
        negative: 35,
        neutral: 32,
      },
    },
  },
  {
    score: {
      positive: 37,
      negative: 28,
      neutral: 35,
    },
    genericQuestionId: 36,
    text: 'Quality of parks and recreational amenities',
    aspectValue: AspectValues.CHARACTERISTIC,
    previousCycle: {
      score: {
        positive: 45,
        negative: 21,
        neutral: 34,
      },
    },
  },
  {
    score: {
      positive: 30,
      negative: 40,
      neutral: 31,
    },
    genericQuestionId: 37,
    text: 'Quality of waste and recycling services',
    aspectValue: AspectValues.CHARACTERISTIC,
    previousCycle: {
      score: {
        positive: 35,
        negative: 28,
        neutral: 36,
      },
    },
  },
  {
    score: {
      positive: 42,
      negative: 25,
      neutral: 33,
    },
    genericQuestionId: 38,
    text: 'Availability of a variety of art and cultural events',
    aspectValue: AspectValues.CHARACTERISTIC,
    previousCycle: {
      score: {
        positive: 51,
        negative: 21,
        neutral: 28,
      },
    },
  },
];

export const noHighlightedRowsMockServicesBarWidgetData: OverallSatisfactionScoreQuestion[] = [
  {
    score: {
      positive: 54,
      negative: 13,
      neutral: 33,
    },
    genericQuestionId: 15,
    text: 'How is the overall quality with which the Abilene government provides services to residents of Abilene today compared to 3 years ago?',
    aspectValue: AspectValues.QUALITY_OF_LIFE,
  },
  {
    score: {
      positive: 46,
      negative: 26,
      neutral: 29,
    },
    genericQuestionId: 16,
    text: 'How likely are you to recommend Abilene as a place to live?',
    aspectValue: AspectValues.QUALITY_OF_LIFE,
    previousCycle: {
      score: {
        positive: 48,
        negative: 24,
        neutral: 28,
      },
    },
  },
];

export const highlightedRowsMockServicesBarWidgetData: OverallSatisfactionScoreQuestion[] = [
  {
    score: {
      positive: 54,
      negative: 13,
      neutral: 33,
    },
    previousCycle: {
      score: {
        positive: 48,
        negative: 24,
        neutral: 28,
      },
    },
    genericQuestionId: 15,
    text: 'How is the overall quality with which the Abilene government provides services to residents of Abilene today compared to 3 years ago?',
    aspectValue: AspectValues.QUALITY_OF_LIFE,
  },
  {
    score: {
      positive: 56,
      negative: 16,
      neutral: 29,
    },
    genericQuestionId: 16,
    text: 'How likely are you to recommend Abilene as a place to live?',
    aspectValue: AspectValues.QUALITY_OF_LIFE,
    previousCycle: {
      score: {
        positive: 48,
        negative: 24,
        neutral: 28,
      },
    },
  },
  {
    score: {
      positive: 56,
      negative: 16,
      neutral: 29,
    },
    genericQuestionId: 17,
    text: 'How likely are you to recommend Abilene as a place to live?',
    aspectValue: AspectValues.QUALITY_OF_LIFE,
    previousCycle: {
      score: {
        positive: 48,
        negative: 24,
        neutral: 28,
      },
    },
  },
];
